import React from 'react';
import { connect } from 'react-redux';

import Input from '@components/Input';
import { 
  setPedestalPedestalDepth, 
  setPedestalPedestalHeight, 
  setPedestalFinishDepth, 
  setPedestalGroundDepth 
} from '@reducers/options/ground/actions';
import { APP_TEXTS } from '../../../../texts/texts';
import { Tooltip } from '@components/Tippy';
import { APP_TOOLTIPS } from '../../../../../src/texts/tooltips';
import { unitLabel, unitTransform } from '@services/helper.service';
import { defaultUnits } from '@config';

const PedestalDimensions = props => (
  <div className="calculation">
    <section className="list-type">
      <h4>{APP_TEXTS.PEDESTAL_THICKNESS.Content}</h4>
      <Tooltip content={APP_TOOLTIPS.TOOLTIP_PEDESTAL_THICKNESS.Content}>
        <Input
          id="h1"
          prefix="H1:"
          postfix={unitLabel(props.unit)}
          type="number"
          minValue={0}
          value={unitTransform(props.pedestal.pedestal.depth || 0).from(defaultUnits.DISTANCE).to(props.unit)}
          onUpdate={value => {
            props.setH1(unitTransform(value || 0, false).from(props.unit).to(defaultUnits.DISTANCE));
          }}
        />
      </Tooltip>

      <h4>{APP_TEXTS.SLAB_THICKNESS.Content}</h4>
      <Tooltip content={APP_TOOLTIPS.TOOLTIP_SLAB_THICKNESS.Content}>
        <Input
          id="h2"
          prefix="H2:"
          postfix={unitLabel(props.unit)}
          type="number"
          minValue={0}
          value={unitTransform(props.pedestal.ground.depth || 0).from(defaultUnits.DISTANCE).to(props.unit)}
          onUpdate={value => {
            props.setH2(unitTransform(value || 0, false).from(props.unit).to(defaultUnits.DISTANCE));
          }}
        />
      </Tooltip>

     
      <h4>{APP_TEXTS.PEDESTAL_WIDTH.Content}</h4>
      <Tooltip content={APP_TOOLTIPS.TOOLTIP_PEDESTAL_WIDTH.Content}>
        <Input
          id="w"
          prefix="W:"
          postfix={unitLabel(props.unit)}
          type="number"
          minValue={0}
          value={unitTransform(props.pedestal.pedestal.height || 0).from(defaultUnits.DISTANCE).to(props.unit)}
          onUpdate={value => {
            props.setW(unitTransform(value || 0, false).from(props.unit).to(defaultUnits.DISTANCE));
          }}
        />
      </Tooltip>

      <h4>{APP_TEXTS.FINISH_SLAB_HEIGHT.Content}</h4>
      <Tooltip content={APP_TOOLTIPS.TOOLTIP_SLAB_HEIGHT.Content}>
        <Input
          id="href"
          prefix="Href:"
          postfix={unitLabel(props.unit)}
          type="number"
          minValue={0}
          value={unitTransform(props.pedestal.finish.depth || 0).from(defaultUnits.DISTANCE).to(props.unit)}
          onUpdate={value => {
            props.setHref(unitTransform(value || 0, false).from(props.unit).to(defaultUnits.DISTANCE));
          }}
        />
      </Tooltip>
    </section>
  </div>
);

const mapState = state => ({
  pedestal: state.options.ground.pedestal,
  unit: state.main.units.distance
});

const mapDispatch = dispatch => ({
  setH1: value => dispatch(setPedestalPedestalDepth(parseFloat(value))),
  setH2: value => dispatch(setPedestalGroundDepth(parseFloat(value))),
  setW: value => dispatch(setPedestalPedestalHeight(parseFloat(value))),
  setHref: value => dispatch(setPedestalFinishDepth(parseFloat(value)))
});

export default connect(mapState, mapDispatch)(PedestalDimensions);



// WEBPACK FOOTER //
// ./src/views/Dimension/components/PedestalDimensions/index.js